var map = {
	"./abdomen.png": 52635,
	"./ankle.png": 81744,
	"./arm.png": 36728,
	"./behind-leg.png": 95038,
	"./calf.png": 63145,
	"./chest.png": 87379,
	"./finger.png": 16063,
	"./head.png": 71971,
	"./hip.png": 32178,
	"./joint.png": 28666,
	"./knee.png": 72627,
	"./lower-back.png": 63929,
	"./shin.png": 40602,
	"./shoulder-2.png": 39829,
	"./shoulder.png": 40562,
	"./thigh.png": 58111,
	"./toenail.png": 25409,
	"./upper-back.png": 72629,
	"./waist.png": 88698,
	"./wrist.png": 24476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71899;